import type { Dispatch, SetStateAction } from "react";
import { Icon } from "@/shared";

export const Slider = ({
  value,
  setValue,
}: {
  value: number;
  setValue: Dispatch<SetStateAction<number>>;
}) => (
  <>
    <input
      type="range"
      min={0}
      max={100}
      value={value}
      name="slider"
      className="tw-absolute tw-left-1/2 tw-top-1/2 tw-z-[5] tw-size-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-cursor-[inherit] tw-appearance-none tw-bg-[transparent] tw-opacity-0"
      onChange={(e) => setValue(Number(e.target.value))}
    />
    <div className="tw-pointer-events-none">
      <span
        className="tw-bloc tw-absolute tw-top-0 tw-z-[5] tw-h-full tw-w-[3px] -tw-translate-x-1/2 tw-bg-white"
        style={{ left: `${value}%` }}
      ></span>
      <div
        style={{ left: `${value}%` }}
        className="tw-absolute tw-top-1/2 tw-z-[5] tw-grid tw-size-6 -tw-translate-x-1/2  -tw-translate-y-1/2 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-bg-white"
      >
        <Icon icon="ri-expand-left-right-line" size={18} color="#88819F" />
      </div>
    </div>
  </>
);
